export default function BottomArrow() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 37 33" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.410156 15L4.81244 10.5977L15.3 21.0853L15.2973 0.112884L21.5239 0.113697L21.5266 21.0767L32.002 10.6013L36.4054 15.0047L22.8124 28.5977L18.4102 33L14.0067 28.5966L0.410156 15Z" fill="currentColor" />
        </svg>

    )
}